import BaseService from "./BaseService";
import { FetchDataParam } from "types/api.types";
import { AxiosResponse } from "axios";

const ApiService = {
  fetchData(param: FetchDataParam): Promise<AxiosResponse> {
    return new Promise((resolve, reject) => {
      BaseService(param)
        .then((response) => {
          resolve(response);
        })
        .catch((errors) => {
          reject(errors);
        });
    });
  },
};

export default ApiService;
